import React, { useEffect, useState } from 'react'
import { Icons } from '../../lib/Icons'
import { Link } from 'react-router-dom'

export default function RecentActivity() {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])

  useEffect(() => {
    const t = setTimeout(() => {
      // Placeholder demo data; integrate with your activity source if available
      setItems([])
      setLoading(false)
    }, 600)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-sm">
      <div className="p-6">
        <h2 className="text-base font-medium text-gray-900">Recent Activity</h2>
        {loading ? (
          <div className="mt-6 space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-12 w-full rounded bg-gray-100 animate-pulse" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="mt-6">
            <div className="text-center">
              <Icons.Clock className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-semibold text-gray-900">No activity yet</h3>
              <p className="mt-1 text-sm text-gray-500">Get started by adding students and creating plans.</p>
              <div className="mt-6">
                <Link
                  to="/student-organization"
                  className="inline-flex items-center rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600"
                >
                  Add a student
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-6 flow-root">
            <ul className="-my-5 divide-y divide-gray-200">
              {items.map((it) => (
                <li key={it.id} className="py-4">
                  <div className="flex items-center space-x-4">
                    <div className="shrink-0">
                      <Icons.Clock className="h-5 w-5 text-gray-400" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-gray-900">{it.title}</p>
                      <p className="truncate text-sm text-gray-500">{it.time}</p>
                    </div>
                    {it.cta && (
                      <div>
                        <Link
                          to={it.cta.href}
                          className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
                        >
                          {it.cta.label}
                        </Link>
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

